<div class="container">
  <h1>Welcome to Cerberus</h1>
  <p class="subtitle">Looks like your access needs to be configured.</p>
  <p>Please contact your administrator for support.</p>
  <a
    href="mailto:katia.gutierrez@astrazeneca.com?cc=roger.lobo@astrazeneca.com,rose.adibi@astrazeneca.com"
    target="_blank"
    class="secondary"
  >
    Request Support
  </a>
</div>
